import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const block = this.element.getAttribute("data-scroll-block") || "end";
    this.element.scrollIntoView({ behavior: "smooth", block: block });
  }
}
